import { Box, Button, Checkbox, Heading, Text, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { iColaboradorBase } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'

interface iPesquisa {
  id: string
  nomePesquisa?: string
  visualizacaoRestringida?: boolean
  usuariosPermitidos?: string[]
}

export const RestringirVisualizacao: React.FC = () => {
  const { id } = useParams()
  const toast = useToast()

  const [pesquisa, setPesquisa] = useState<iPesquisa>()
  const [administradores, setAdministradores] = useState<iColaboradorBase[]>([])

  function getPesquisaById(): void {
    appApi.get(`PesquisaAnaliseDesempenho/${id}`)
      .then(response => {
        setPesquisa(response.data)
      })
      .catch(err => console.log(err))
  }

  function getAdministradoresDoSistema(): void {
    appApi.get('Colaborador/Administradores')
      .then(response => {
        setAdministradores(response.data)
      })
      .catch(err => console.log(err))
  }

  function toggleUsuarioPermitido(usuarioId: string, checked: boolean): void {
    setPesquisa(prev => {
      if (!prev) return prev

      const usuariosAtuais = prev.usuariosPermitidos ?? []

      if (checked) {
        if (usuariosAtuais.includes(usuarioId)) return prev

        return {
          ...prev,
          usuariosPermitidos: [...usuariosAtuais, usuarioId]
        }
      }

      return {
        ...prev,
        usuariosPermitidos: usuariosAtuais.filter(id => id !== usuarioId)
      }
    })
  }

  function enviarFormulario(): void {
    const form = {
      id: pesquisa?.id,
      nomePesquisa: pesquisa?.nomePesquisa,
      visualizacaoRestringida: pesquisa?.visualizacaoRestringida,
      usuariosPermitidos: pesquisa?.usuariosPermitidos
    }

    appApi.put(`PesquisaPercepcao/${id}/RestringirVisualizacao`, form)
      .then(() => {
        toast({
          title: 'Sucesso!',
          description: 'Suas alterações foram salvas.',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top'
        })
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    getPesquisaById()
  }, [id])

  useEffect(() => {
    getAdministradoresDoSistema()
  }, [])

  useEffect(() => {
    console.log(pesquisa?.visualizacaoRestringida, pesquisa?.usuariosPermitidos)
  }, [pesquisa])

  return (
    <Box
      display="flex"
      minH="80vh"
      bgColor="white"
      m="6rem"
      borderRadius="2xl"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <Heading mb="17rem">
        Selecione administradores que podem visualizar a pesquisa
      </Heading>

      <Box
        fontWeight="bold"
        bgColor="gray.100"
        p="3rem"
        borderRadius="2xl"
        display="flex"
        flexDirection="column"
        gap={4}
        minW="500px"
      >
        <Checkbox
          borderColor="white"
          isChecked={pesquisa?.visualizacaoRestringida ?? false}
          onChange={(e) => {
            const checked = e.target.checked

            setPesquisa(prev => prev && {
              ...prev,
              visualizacaoRestringida: checked,
              usuariosPermitidos: checked ? (prev.usuariosPermitidos ?? []) : []
            })
          }}
        >
          Visualização restrita
        </Checkbox>

        {pesquisa?.visualizacaoRestringida && (
          <Box display="flex" flexDirection="column" gap={3} mt={2}>
            <Text fontSize="md">
              Administradores permitidos:
            </Text>

            {administradores.length > 0
              ? (
                  administradores.map(admin => (
                <Checkbox
                  key={admin.id}
                  isChecked={pesquisa.usuariosPermitidos?.includes(admin.id) ?? false}
                  onChange={(e) => toggleUsuarioPermitido(admin.id, e.target.checked)}
                >
                  {admin.nome} {admin.email ? `- ${admin.email}` : ''}
                </Checkbox>
                  ))
                )
              : (
              <Text fontSize="sm" color="gray.500">
                Nenhum administrador encontrado.
              </Text>
                )}
          </Box>
        )}
      </Box>
      <Button onClick={enviarFormulario} mt={'12rem'} bgColor={'green'}>Salvar</Button>
    </Box>
  )
}
